import { render, staticRenderFns } from "./myPage.vue?vue&type=template&id=36c3fc4c&scoped=true"
import script from "./myPage.vue?vue&type=script&lang=js"
export * from "./myPage.vue?vue&type=script&lang=js"
import style0 from "./myPage.vue?vue&type=style&index=0&id=36c3fc4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c3fc4c",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/myPage.vue
// module id = null
// module chunks = 